import ProxyBase from '../../../../core/proxies/ProxyBase'

class CategoryProxy extends ProxyBase {
  getLocation(params) {
    return this.get('Category/Location', params)
  }

  getVietnameseLocation(params) {
    return this.get('Category/VietnameseLocation', params)
  }

  getVsic(params) {
    return this.get('Category/VSIC', params, undefined, true)
  }

  getIcb(params) {
    return this.get('Category/ICB', params)
  }

  getTimezone(params) {
    return this.get('Category/Timezones', params)
  }

  getLegalRegulations(params) {
    return this.get('Category/ReportForm', params)
  }

  getPricingPackages(params) {
    return this.get('UserManagement/PricingPackages', params)
  }

  getPricingPackagesByUserType(params) {
    return this.get('UserManagement/PricingPackages/ByUserType', params)
  }

  getExchangeRates(params) {
    return this.get('Setting/ExchangeRates', params)
  }

  getVAT(params) {
    return this.get('Setting/VatPercentage', params)
  }

  getCompanyHeader(params) {
    return this.get('CompanyProfile/CompanyHeader', params, undefined, true)
  }

  getUserProfile(params) {
    return this.get('UserManagement/UserProfile', params)
  }

  getVietnameseProvinces(params) {
    return this.get('Category/VietnameseProvinces', params)
  }

  getForeignRegions(params) {
    return this.get('Category/ForeignRegions', params)
  }

  getJobTitles(params) {
    return this.get('Category/JobTitles', params)
  }

  getCountries(params) {
    return this.get('Category/Countries', params)
  }

  getDiscountOrder(params) {
    return this.get('DiscountAndVoucher/Discounts', params)
  }

  putLanguage(params) {
    return this.put('UserManagement/Language', params)
  }
}

export default new CategoryProxy()
